export default __webpack_public_path__ + "44308c98696eb547d3dde481a9960e81.jpg";